import React from 'react';
import { Breadcrumb } from 'react-bootstrap';

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  children?: JSX.Element;
}
export interface BreadcrumbItem {
  active?: boolean;
  href?: string;
  label?: React.ReactNode;
  onClick?: () => void;
}
const BreadcrumbBox: React.FC<BreadcrumbProps> = ({ items, children }) => {
  const generateItem = () => {
    return items.map((item) => (
      <Breadcrumb.Item
        key={`bc-${item.label}`}
        href={item.href}
        active={item.active}
        onClick={item.onClick}
      >
        {item.label}
      </Breadcrumb.Item>
    ));
  };

  return (
    <>
      <Breadcrumb>{generateItem()}</Breadcrumb>
      {children}
    </>
  );
};

export default BreadcrumbBox;
